import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ClerkProvider } from '@clerk/clerk-react'
import { clerkProviderAppearance } from './theme/clerkAppearance.ts'
import { QueryClient, QueryClientProvider, QueryCache } from '@tanstack/react-query'
import App from './App.tsx'
import { ApiRequestError } from './api/client.ts'
import './index.css'

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable')
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError(error) {
      if (error instanceof ApiRequestError) {
        if (error.code === 'missing_organization') {
          window.dispatchEvent(new CustomEvent('api-missing-organization'))
          return
        }
        if (error.status === 401 || error.status === 403) {
          window.dispatchEvent(
            new CustomEvent('api-auth-error', { detail: { status: error.status } }),
          )
        }
      }
    },
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ClerkProvider
      publishableKey={PUBLISHABLE_KEY}
      signInUrl="/sign-in"
      appearance={clerkProviderAppearance}
    >
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ClerkProvider>
  </StrictMode>,
)
